module.exports = __webpack_public_path__ + "img/pin2.5b0dc4bb.png";